<template>
  <div id="cert_application_submit_data_preview" @click="backViewClicked">
    <div v-if="judge">
      <div style="font-size: 1.5rem;margin-bottom: 30px;">已提交信息</div>
      <div class="row">
        <div class="column">*姓名：</div>
        <div class="column">{{judge.name}}</div>
      </div>

<!--      <div class="row">-->
<!--        <div class="column">*性别：</div>-->
<!--        <div class="column">{{judge.sex}}</div>-->
<!--      </div>-->

      <div class="row">
        <div class="column">*身高：</div>
        <div class="column">{{judge.height + ' cm'}}</div>
      </div>

      <div class="row">
        <div class="column">*体重：</div>
        <div class="column">{{judge.weight + ' kg'}}</div>
      </div>

      <div class="row">
        <div class="column">*服装尺码：</div>
        <div class="column">{{judge.clothSize}}</div>
      </div>

      <div class="row">
        <div class="column">*鞋码：</div>
        <div class="column">{{judge.shoeSize}}</div>
      </div>

<!--      <div class="row">-->
<!--        <div class="column">*证件：</div>-->
<!--        <div class="column">{{judge.idType}}</div>-->
<!--      </div>-->

      <div class="row">
        <div class="column">*身份证号码：</div>
        <div class="column">{{judge.idNo}}</div>
      </div>

      <div class="row">
        <div class="column">*近期免冠照：</div>
        <div class="column">
          <el-image :src="judge.photo" class="avatar" style="max-width: 200px;max-height: 200px;" />
        </div>
      </div>

      <div class="row">
        <div class="column">*英语等级：</div>
        <div class="column">{{judge.englishLevel}}</div>
      </div>

      <div class="row">
        <div class="column">*工作情况：</div>
        <div class="column">{{judge.jobStatus}}</div>
      </div>

      <div v-if="judge.jobStatus != '已退休'" class="row">
        <div class="column">*所在单位：</div>
        <div class="column">{{judge.unit}}</div>
      </div>

      <div class="row">
        <div class="column">*证书类型：</div>
        <div class="column">裁判员</div>
      </div>

      <div class="row">
        <div class="column">*证书等级：</div>
        <div class="column">{{judge.certificateLevel}}</div>
      </div>

      <div class="row">
        <div class="column">*批准年份：</div>
        <div class="column">{{judge.yearOfApproval}}</div>
      </div>

      <div class="row">
        <div class="column">*批准单位：</div>
        <div class="column">{{judge.unitOfApproval}}</div>
      </div>

      <div class="row" v-if="judge.certificateNo != null && judge.certificateNo.length > 0">
        <div class="column">证件编码：</div>
        <div class="column">{{judge.certificateNo}}</div>
      </div>

      <div class="row">
        <div class="column">*证书照片：</div>
        <div class="column">
          <el-image v-for="(item, index) in certificatePhotos" :key="'certificate_photo_' + index"
              :src="item" fit="cover" class="avatar certificate-photo"/>
        </div>
      </div>

      <div class="row" v-if="judge.experience != null && judge.experience.length > 0">
        <div class="column">执裁经历：</div>
        <div class="column">{{judge.experience}}</div>
      </div>

      <div class="row">
        <div class="column">*联系人电话：</div>
        <div class="column">{{judge.mobile}}</div>
      </div>


      <div class="iconfont close-button">&#xe639;</div>

    </div>
  </div>
</template>

<script>
export default {
  name: "CertApplicationSubmitDataPreview",
  props: {
    judge: {
      default:()=> null
    }
  },
  data() {
    return {

    }
  },

  computed: {
    certificatePhotos() {
      let judge = this.judge;
      if (judge == null || judge == undefined) {
        return [];
      }
      let certificatePhoto = judge.certificatePhoto;
      if (certificatePhoto == null || certificatePhoto == '') {
        return [];
      }
      let tmpArray = certificatePhoto.split(',');
      return tmpArray;
    }
  },
  mounted() {
    // console.log(this.judge);
  },

  methods: {
    backViewClicked() {
      // console.log('---2');
      this.$emit('close');
    },
    getImageList(item) {
      let certificatePhoto = item.certificatePhoto;
      console.log(certificatePhoto);
      if (certificatePhoto == null || certificatePhoto == '') {
        console.log('----1-l');
        return [];
      }

      let tmpArray = certificatePhoto.split(',');
      console.log(tmpArray.length);
      console.log(tmpArray);
      return tmpArray;
    }
  }
}
</script>

<style scoped>
  #cert_application_submit_data_preview {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  #cert_application_submit_data_preview > div {
    width: 90%;
    max-height: 90%;
    max-width: 500px;
    min-height: 500px;
    background-color: white;
    border: solid 1px lightgrey;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 30px 15px;
    overflow-y: visible;
    overflow-x: hidden;
    position: relative;
  }

  #cert_application_submit_data_preview .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
  }

  #cert_application_submit_data_preview .row:not(:last-child) {
    margin-bottom: 10px;
  }

  #cert_application_submit_data_preview .row .column:first-child {
    width: 30%;
    text-align: right;
    padding-right: 5px;
  }

  #cert_application_submit_data_preview .row .column:not(:first-child) {
    width: 70%;
    padding-left: 5px;
    font-weight: bold;
  }

  #cert_application_submit_data_preview .certificate-photo {
    padding: 5px;
    max-width: 150px;
    max-height: 150px;
    vertical-align: middle;
  }


  #cert_application_submit_data_preview .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 1.5rem;
    font-weight: bold;
  }


</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationSubmitDataPreview.vue